import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function OrderContentReducer(state = initialState.orderContent, action: any) {
  switch (action.type) {
    case types.SAVE_ORDERCONTENT_SUCCESS:
      return action.orderContent;
    default:
      return state;
  }
}
